import { Component, OnInit, ViewChild} from '@angular/core';
import { Router,ActivatedRoute  } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {OrderDetailComponent} from '../order-detail/order-detail.component';
import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver/FileSaver';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-close-orders-list-report',
  templateUrl: './close-orders-list-report.component.html',
  styleUrls: ['./close-orders-list-report.component.scss']
})
export class CloseOrdersListReportComponent implements OnInit {
  userId: any;
  userToken: any;
  listOrders: any = [];
  temp: any = [];
  load = true;
  expanded: any = {};
  @ViewChild('table', { static: false }) table: any;

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  providersList=[];
  data: any = {};
  providerActive = false;
  isExternal;
  perfilId;
  arrOc = [];
  arrOcUUID = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];
  listPlanta = [];
  listPlantaSel = [];
  GuidFactura: string= null;

  constructor(
    private toastr: ToastrService,
    public dialog: MatDialog,
    private gralService: GeneralService,
    private groupService: GroupService,
    private provService: ProvidersService,
    private route: ActivatedRoute,
    private translate: TranslateService
    
  ){

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    gralService.changeTextHead('LISTCONCILIACION');

    //this.getOrders();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == '3' && this.isExternal) ? false : true;

    this.getSocieties();
    this.getPlantas();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.data.FechaFin = new Date();

      this.GuidFactura = this.route.snapshot.paramMap.get('guid');
      console.log("GuidFactura %o",this.GuidFactura);
      if( this.GuidFactura ){
            this.searchFactura();
      }
  }

  getOrders(){
    this.provService.getCloseOrders(this.userId, this.userToken).then((data) => {
      this.load = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.reorderDataExportExcel(data['Entidades']);
    }, (err) => {
      console.log(err);
      this.listOrders = null;
      this.temp = null;
      this.load = false;
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  detail(GuidRecepcionFactura){
    this.provService.getCloseOrder(GuidRecepcionFactura, this.userToken).then((data) => {
      this.dialog.open(OrderDetailComponent, {
        minWidth: '80%',
        position: {
          top: '6%'
        },
        data: { type: 'detail', info: data['Entidad'], id: GuidRecepcionFactura }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  /*
  detailApprove(GuidRecepcionFactura){
    this.provService.getCloseOrder(GuidRecepcionFactura, this.userToken).then((data) => {
      const dialogDetail =this.dialog.open(OrderDetailComponent, {
        minWidth: '80%',
        position: {
          top: '6%'
        },
        data: { type: 'detail', info: data['Entidad'], id: GuidRecepcionFactura, approve: true, userId: this.userId }
      });

      dialogDetail.afterClosed().subscribe(result=>{
        if(result){
          this.search();
        }
      });

    }, (err) => {
      console.log(err);
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }*/

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('ordenes_cerradas'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    this.listExcel =  [];

    for(let i = 0; i < lista.length; i++){
      let contTable = lista[i].RecepcionFactura;

      let params = {
          "Serie": contTable.Serie,
          "Folio": contTable.Folio,
          "UUID": contTable.UUID,
          "RFC Emisor" : contTable.RFCEmisor,
          "Número de proveedor": contTable.NumProveedor,
          "Nombre del Proveeddor": contTable.NombreProveedor,
          "Planta" : contTable.Planta,
          "Fecha de emisión": contTable.FechaEmision,
          "Fecha de carga" : contTable.FechaCarga,
          "Estatus": contTable.EstatusProcesoFactura.Descripcion,
          "Doc. Factura":  (lista[i].Resultado && lista[i].Resultado.InvoiceDocumentMiro) ? lista[i].Resultado.InvoiceDocumentMiro: 0 ,
          "Año Doc. Factura": (lista[i].Resultado && lista[i].Resultado.InvoiceDocumentYearMiro) ?  lista[i].Resultado.InvoiceDocumentYearMiro :0
      }
      this.listExcel.push(params);
    }
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data //
    const temp = this.temp.filter(function(d) {
      let ret = d.RecepcionFactura.Serie.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.RecepcionFactura.Folio.indexOf(val) !== -1 || !val;
      ret = ret+d.RecepcionFactura.RFCEmisor.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret + d.RecepcionFactura.NumProveedor.indexOf(val) !== -1 || !val;
      ret = ret + d.RecepcionFactura.NombreProveedor.indexOf(val) !== -1 || !val;
      ret = ret+d.RecepcionFactura.FechaEmision.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.RecepcionFactura.FechaCarga.toLowerCase().indexOf(val) !== -1 || !val;

      return ret;
    });
    // update the rows
    this.listOrders = temp;
  }


  /* ********************* filtros ************** */
  search(){
    this.data.Proveedor = this.arrOc.join();
    this.data.uuid = this.arrOcUUID.join();

    if(!this.data.FechaInicio || !this.data.FechaFin || !this.data.uuid){
      let body = "Favor de ingresar todos los campos";
      if(this.translate.currentLang == "es"){
        body = "Favor de ingresar todos los campos";
      }else if(this.translate.currentLang == "en"){
        body = "Please enter all fields xs";
      }
      this.toastr.error(body, 'Error');
      return;
    }

    this.listOrders = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {
      FechaFin: datePipe.transform(dateend, 'yyyy/MM/dd'),
      FechaInicio: datePipe.transform(dateinit, 'yyyy/MM/dd'),
      Proveedor: this.data.Proveedor,
      Sociedad: this.data.Sociedad,
      usuario: this.userId,
      Planta: this.data.Plant,
      uuid: this.data.uuid
    };

    this.provService.getCloseOrdersReport(params, this.userToken).then((data) => {
      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.reorderDataExportExcel(data['Entidades']);

      if(this.listOrders.length == 0){
        let title = "Sin datos";
        let body = "No se encontraron resultados para su busqueda";
        if(this.translate.currentLang == "es"){
          title = "Sin datos";
          body = "No se encontraron resultados para su busqueda";
        }else if(this.translate.currentLang == "en"){
          body = "No results for your search";
          title = "No data";
        }
        this.toastr.success(body,title);
        return false;
      }

    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  private searchFactura()
  {
    this.listOrders = [];
    this.loadBtn = true;

    const params = {
      FechaFin: null,
      FechaInicio: null,
      Proveedor: null,
      Sociedad: null,
      Uuid: null,
      GuidFactura : this.GuidFactura,
      usuario: this.userId
    };

    this.provService.getCloseOrdersReport(params, this.userToken).then((data) => {
      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.reorderDataExportExcel(data['Entidades']);

      if(this.listOrders.length == 0){
        let title = "Sin datos";
        let body = "No se encontraron resultados para su busqueda";
        if(this.translate.currentLang == "es"){
          title = "Sin datos";
          body = "No se encontraron resultados para su busqueda";
        }else if(this.translate.currentLang == "en"){
          body = "No results for your search";
          title = "No data";
        }
        this.toastr.success(body,title);
        return false;
      }

    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  disabledProv(){
    let resp = false;

    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;

      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    console.log('entro', value)
    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  adduuid(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    console.log('entro', value)
    // Add our fruit
    if ((value || '').trim()) {
      this.arrOcUUID.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }


  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  removeuuid(oc): void {
    const index = this.arrOcUUID.indexOf(oc);
    if (index >= 0) {
      this.arrOcUUID.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  pasteuuid(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOcUUID.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOcUUID.push(value.trim());
          }
        }
      })
  }


  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];

        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos) {

    //if (this.perfilId == 3)
    console.log("providerActive %o", this.providerActive);

    if (!this.providerActive) {
      console.log("selectSociety %o", pos);
      let List = this.listSocieties;
      this.arrOc = [];
      console.log(List[pos].NumProveedor);
      this.arrOc.push(List[pos].NumProveedor);
    }

    this.listPlantaSel = this.listPlanta.filter(x => x.IdSociedad == this.listSocieties[pos].IdSociedad || x.IdSociedad  == 0 );
    this.data.Plant = null;
  }

  getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectPlanta(index){

    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.Plant = planta.NoPlanta;
    }

  }

  /* ********************* filtros ************** */

  /* ********************* checkbox ************** */
  checkedAll = false;
  selectAll(){
    for(let g = 0; g < this.listOrders.length; g++){
      this.listOrders[g].select = this.checkedAll;
      //this.sumTot();
    }
  }

  DescargaMasiva(){
    this.filterUUID((res)=>{
      console.warn(res);

      if(res.length >0){
        const _tempUUID = {uuid: res };
        this.provService.descargaMasiva(_tempUUID, 'llll').then((res:any)=>{
        this.loadBtn = false;
        if(res.resultado){
          let mimeType;
          if(res.Entidad.esPdf || res.Entidad.esXml ){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });


            if(!res.Entidad.esZip){
              mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
            }else{
              mimeType =  '.zip';
            }

            let fileName= Date.now();
            let tempName = fileName+mimeType;

            saveAs(blob, tempName);
          }else if(res.Entidad.esZip){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
            mimeType =  '.zip';
            let fileName= Date.now();
            let tempName = fileName+'.zip';

            saveAs(blob, tempName);
          }
        }


        });
      }else{
        let title = "Descargar masiva";
        let msgRequired = "Debe seleccionar al menos una factura";
        if(this.translate.currentLang == "es"){
          title = "Descargar masiva";
          msgRequired = "Debe seleccionar al menos una factura";
        }else if(this.translate.currentLang == "en"){
          msgRequired = "You must select at least one invoice";
          title = "Bulk download";
        }
        this.toastr.info(msgRequired,title);
      }
    })

  }

  filterUUID(callbak){
    let finalList = [];

    for(let i = 0; i < this.listOrders.length; i++ ){
      if(this.listOrders[i].select){
        let _UUID = this.listOrders[i].RecepcionFactura.UUID;
        finalList.push(_UUID);
      }
    }
    return callbak(finalList);
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }


  /* ********************* checkbox ************** */

  download(fieldUUID){
    //let fieldUUID = this.listOrders[pos].RecepcionFactura.UUID;

    this.provService.downloadFiles( fieldUUID,'111').then((res:any) => {

      if(res.resultado){
        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });

          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }else{
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
          let mimeType =  '.zip';

          let fileName= Date.now();
          let tempName = fileName+mimeType;
          console.log(tempName);
          saveAs(blob, tempName);
        }
      }
    });
  }



}

